module.exports = __webpack_public_path__ + "fonts/AguafinaScript-Regular.c64ed887.ttf";